@if (year && pyramids.length > 0) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <div>{{ year }}</div>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      @if (!showTextView) {
        <div class="chart-container">
          <canvas
            baseChart
            [data]="pieChartData"
            [options]="pieChartOptions"
            [type]="pieChartType">
          </canvas>
        </div>
      } @else {
        <div class="text-view">
          <table class="data-table">
            <thead>
              <tr>
                <th>Entity</th>
                <th>Percentage</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (pyramid of sortedPyramids; track pyramid.id) {
                <tr>
                  <td>{{ getPyramidName(pyramid) }}</td>
                  <td>{{ pyramid.percentage.toFixed(2) }}%</td>
                  <td class="actions-cell">
                    <button mat-icon-button
                            (click)="onDeletePyramid(pyramid.id, $event)"
                            class="delete-button">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </mat-card-content>
  </mat-card>
}
